export * from './branchname.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/branchname/index.ts